
import Group from 'vux/src/components/group/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Previewer from 'vux/src/components/previewer/index.vue'

import { mapActions } from 'vuex'


export default {
name: 'CustomExplain',
components: {
Group,
XHeader,
Previewer,
},
data() {
return {
body: {},
imgList: [],
}
},
computed: {

},
methods: {
...mapActions(['showToast']),
generateImgList() {
const images = document.querySelectorAll('.custom-explain-wrapper img')
return Array.from(images).map(img => ({
src: img.src,
w: img.getAttribute('data-width') || 600,
h: img.getAttribute('data-height') || 400,
}))
},
popUpImg(event) {
if (event.target.tagName === 'IMG') {
const idx = this.imgList.map(im => im.src).indexOf(event.target.src)
this.$refs.previewer.show(idx !== -1 ? idx : 0)
}
},
},
created() {
this.$http.get('/api/content/7')
.then((data) => {
this.body = data.body
this.imgList = this.generateImgList()
})
},
}



// WEBPACK FOOTER //
// ./client/components/Custom/CustomExplain.vue